import type { EventTypeInfo } from '../types';

import { defaultState } from './defaultState';

type State = typeof defaultState;

export const reducers = {
  eventTypeInfoRequested: (state: State): State => ({
    ...state,
    isLoading: true
  }),
  clear: (): State => ({ ...defaultState }),
  dataLoadSuccess: (_state: State, payload: EventTypeInfo): State => ({
    eventTypeInfo: payload,
    isLoading: false,
    hasPreloaded: true
  }),
  dataLoadFailed: (state: State): State => ({
    ...state,
    isLoading: false,
    hasPreloaded: true
  })
};
